export const MY_PRODUCT = 'My Product';
export const PCF = 'PCF';
export const CCF = 'CCF';
export const UPSTREAM = 'upstream';
export const DOWNSTREAM = 'downstream';
export const CURRENT = 'current';
export const DIRECTION = {
  UPSTREAM: 'upstream',
  DOWNSTREAM: 'downstream',
  CURRENT: 'current',
} as const;
